import { expVal } from '@atlassian/jira-feature-experiments';

const ContextSectionsReorderingExperimentRelayProvider = {
	get(): boolean {
		return expVal('context_sections_reordering', 'isEnabled', false);
	},
};

export default ContextSectionsReorderingExperimentRelayProvider;
